<template>
	<div class="user-dropdown">
		<div class="user-button">
			<v-avatar size="auto" class="mr-2">
				<!-- <img src="@/img/coruja.jpg" alt="Mascote"> -->
			</v-avatar>
			<v-icon class="mr-2">mdi-account</v-icon>
			<span class="d-none d-sm-block font-weight-light">{{ user.usuario }}</span>
			<i class="fa fa-angle-down ml-2"></i>
		</div>
		<div class="user-dropdown-content">
			<router-link to="/configuracoes" v-show="isPerfilGestao">
				<i class="fa fa-cog"></i>Administração
			</router-link>
			<a href @click.prevent="logout"><i class="fa fa-sign-out"></i>
				Sair
			</a>
		</div>
	</div>
</template>

<script>
	import { userKey } from '@/global'
	import { mapState } from 'vuex'
	// import Bus from '@/barramento'
	export default {

		name: 'UserDropdown',
		methods:{
			logout() {
				// Bus.$emit('logout', this.user.id)
				localStorage.removeItem(userKey)
				this.$store.commit('setUser', null)
				this.$router.push({ name: 'auth' })

			}
		},
		computed: {
			...mapState(['user']),
			isPerfilGestao() {
				const tipo = String(this.user?.tipo || '').trim().toLowerCase()
				return ['admin', 'master', 'gerente', 'coordenador', 'financeiro', 'supervisor'].includes(tipo)
			}
		},
	};
</script>

<style lang="css" scoped>
	.user-dropdown {
		position: relative;
		height: 100%
	}

	.user-button {
		display: flex;
		align-items: center;
		color: #fff;
		background-color: rgba(0, 0, 77, 0.88);
		border-radius: 4px;
		margin: 8px;
		font-weight: 400;
		height: calc(100% - 16px);
		padding: 0px 16px;
		transition: background-color 0.2s;
	}

	.user-dropdown:hover .user-button {
		background-color: #00004d;
	}

	.user-dropdown-content {
		position: absolute;
		right: 8px;
		top: 100%;
		background-color: white;
		min-width: 180px;
		box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.15);
		border-radius: 4px;
		border: 1px solid #e0e0e0;
		padding: 8px 0;
		z-index: 1000;

		display: flex;
		flex-direction: column;

		visibility: hidden;
		opacity: 0;
		transition: visibility 0s, opacity 0.2s ease;
	}

	.user-dropdown:hover .user-dropdown-content {
		visibility: visible;
		opacity: 1;
	}

	.user-dropdown-content a {
		text-decoration: none;
		color: var(--primary-color);
		padding: 12px 16px;
		font-size: 14px;
		font-weight: 400;
		display: flex;
		align-items: center;
		transition: background-color 0.2s;
	}

	.user-dropdown-content a i {
		margin-right: 8px;
		width: 16px;
		color: var(--primary-color);
	}

	.user-dropdown-content a:hover {
		text-decoration: none;
		color: var(--primary-dark);
		background-color: var(--accent-light);
	}
</style>
